<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0" height="100%">
      <v-col cols="12">
        <v-card height="85vh" class="d-flex align-center justify-center">
          <v-sheet width="90%">
            <v-card-title class="justify-center">
              <div class="text-h5 text-center" v-if="isEventAttendees">
                How EventConnect works for your <br />
                event attendees
              </div>
              <div class="text-h5 text-center" v-else>
                How EventConnect works when <br />organising an event or meeting
              </div>
            </v-card-title>
            <v-card-text class="d-flex justify-center">
              <v-card width="60%">
                <v-carousel
                  hide-delimiter-background
                  light
                  height="400"
                  :show-arrows="false"
                  @change="toggleVideo"
                >
                  <v-carousel-item
                    v-for="video in multiConnectExplainationVideos"
                    :key="video.id"
                  >
                    <iframe
                      width="100%"
                      id="2"
                      height="345"
                      :src="video.src"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                    ></iframe>
                  </v-carousel-item>
                </v-carousel>
              </v-card>
            </v-card-text>
            <v-card-actions v-if="isEventAttendees">
              <v-row justify="center">
                <v-col cols="12" class="text-center">
                  <v-btn
                    width="40%"
                    color="primary"
                    depressed
                    large
                    class="text-body-1"
                    @click="unlockMultiConnectDialog = true"
                    >I’m ready to create a EventConnect link</v-btn
                  >
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn
                    width="40%"
                    color="primary"
                    depressed
                    large
                    class="text-body-1"
                    text
                    @click="handleClick"
                    >I’ll create a EventConnect link later</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
            <v-card-actions
              class="justify-center d-flex flex-column mb-auto"
              v-else
            >
              <v-btn
                width="40%"
                color="primary"
                depressed
                large
                class="text-body-1"
                outlined
                @click="toggleVideo"
                >Next</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
    <UnlockMultiConnectDialog
      :showDialog="unlockMultiConnectDialog"
      @closeDialog="unlockMultiConnectDialog = false"
    />
  </v-container>
</template>
<script>
import UnlockMultiConnectDialog from "@/components/UnlockMultiConnectDialog";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    UnlockMultiConnectDialog,
  },
  computed: {
    ...mapGetters(["businessProfile"]),
  },
  data() {
    return {
      multiConnectExplainationVideos: [
        {
          id: "1",
          src: "https://www.youtube.com/embed/zjcVPZCG4sM",
        },
        {
          id: "2",
          src: "https://www.youtube.com/embed/zjcVPZCG4sM",
        },
      ],
      isEventAttendees: true,
      unlockMultiConnectDialog: false,
    };
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails"]),
    toggleVideo() {
      this.isEventAttendees = !this.isEventAttendees;
    },
    handleClick() {
      this.businessProfile.isMultiConnectOnboarded = true;
      this.updateBusinessProfileDetails({ isMultiConnectOnboarded: true });
      this.$router.push("/multiConnect");
    },
  },
};
</script>
